/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["app-shop[_ngcontent-%COMP%] {\n  width: 100vw;\n  height: 100vh;\n  position: relative;\n  top: 0px;\n  left: 0px;\n}"];
export { styles as styles };
